<script setup>
import {onBeforeMount, reactive, ref} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import {getRoute} from "@/hooks/getRoute.js";
import router from "@/router/index.js";
import moment from "moment";
import YTCheckedPanel from "@/components/YTCheckedPanel/index.vue"
import {detailMember} from "@/api/member/member.js";
import {itemDetail} from "@/api/goods/goods.js";
import YTDrawerItem from "@/components/YTDrawerItem/YTDrawerItem.vue";
import YTDrawerMember from "@/components/YTDrawerMember/YTDrawerMember.vue";
import YTCouponState from "@/components/YTCouponState/YTCouponState.vue";
import {couponStateEnum} from "@/enum/couponStateEnum.js"
import {detailCouponUser, editCouponUser} from "@/api/coupon/coupon.js";

// 路由信息
const {route} = getRoute();

// 是否有优惠券id
const hasId = ref(false)
// 加载状态
const loading = ref(false)

onBeforeMount(async () => {
  hasId.value = Boolean(route.query.couponUserId)
  console.log(route.query.couponUserId)
  // 检测是否携带优惠券id
  if (!hasId.value) {
    loading.value = true
    ElMessage.error("暂无优惠券信息")
    return
  }
  await handleSearch()
})

// 获取订单信息
const handleSearch = async () => {
  try {
    loading.value = true
    const res = await detailCouponUser(route.query.couponUserId)
    console.log("res", res)
    formData.couponUserId = res.couponUserId
    formData.orderNo = res.orderNo
    formData.crTime = moment(res.crTime).format("YYYY-MM-DD HH:mm:ss")
    formData.nickname = res.nickname
    formData.memberId = res.memberId
    formData.userId = res.userId
    formData.phone = res.phone
    formData.note = res.note
    formData.couponImage = res.coupon && res.coupon.images ? res.coupon.images[0] : ""
    formData.couponName = res.coupon && res.coupon.goodsName ? res.coupon.goodsName : "-"
    formData.goodsId = res.goodsId
    formData.validityType = res.coupon.couponInfo.validityType
    formData.validityValue = res.coupon.couponInfo.validityValue
    formData.allowedTriggers = res.allowedTriggers
    formData.coupon = res.coupon
    formData.couponState = res.couponState
    triggerList.value = []
    signTrigger.value.forEach(i => {
      let param = {
        value: i.stateId,
        name: i.stateName
      }
      triggerList.value.push(param)
    })
    loading.value = false
  } catch (e) {
    console.log(e)
  }
}

/*订单相关*/
// 优惠券订单状态枚举
const signTrigger = ref(couponStateEnum)
// 更新优惠券状态可选项
const triggerList = ref([])
// 订单详情信息
const formData = reactive({
  couponUserId: null,
  orderNo: null,
  crTime: null,
  nickname: null,
  memberId: null,
  userId: null,
  phone: null,
  note: null,
  couponImage: null,
  couponName: null,
  goodsId: null,
  validityType: null,
  validityValue: null,
  coupon: null,
  couponState: null,
  allowedTriggers: []
})
// 用户信息抽屉打开状态
const drawer = ref(false)
// 处理点击用户名称跳转
const handleCustomerDetail = async (id) => {
  drawer.value = true
  drawerCacheType.value = 1
  drawerLoading.value = true
  drawerCacheInfo.value = await detailMember(id)
  drawerLoading.value = false
}
// 处理点击优惠券信息跳转
const handleActivityDetail = async () => {
  drawer.value = true
  drawerCacheType.value = 2
  drawerLoading.value = true
  drawerCacheInfo.value = await itemDetail(formData.coupon.goodsId)
  drawerLoading.value = false
}
// 处理关闭用户信息抽屉
const handleCloseDrawer = () => {
  drawer.value = false
  drawerCacheType.value = null
  drawerCacheInfo.value = null
}
// 抽屉缓存类型
const drawerCacheType = ref(null)
// 抽屉缓存信息
const drawerCacheInfo = ref(null)
// 抽屉缓存加载状态
const drawerLoading = ref(false)

/*保存修改相关*/
// 保存内容提交表单
const submit = async (type) => {
  try {
    loading.value = true
    const param = {
      couponUserId: formData.couponUserId,
      userId: formData.userId,
      goodsId: formData.goodsId,
      couponState: type
    }
    await editCouponUser(param)
    loading.value = false
    ElMessage.success("修改订单状态成功")
    router.push("/listCoupon")
  } catch (e) {
    console.log(e)
  }
}

/*页面动画相关*/
// 基本信息锚点
const baseRef = ref()

/*更新状态相关*/
// 多选弹窗打开状态
const open = ref(false)
// 处理多选框取消
const handleCancelPanel = () => {
  open.value = false
}
// 处理多选框确认
const handleConfirmPanel = async (val) => {
  await submit(val[0])
  open.value = false
}
</script>

<template>
  <el-form
      :model="formData"
      label-position="right"
      label-width="auto"
  >
    <div class="container_box mg_b_2" style="padding-bottom: 0;">
      <YTCard ref="baseRef" :title="'基本信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div>
              <el-form-item label="订单编号：" prop="orderNo">
                <el-text class="mx-1" v-text="formData.orderNo"></el-text>
              </el-form-item>
              <el-form-item label="时间：" prop="crTime">
                <el-text class="mx-1" v-text="formData.crTime"></el-text>
              </el-form-item>
              <el-form-item label="用户：" prop="nickname">
                <el-link type="primary" v-text="`${formData.nickname}（${formData.phone}）`" :underline="false" @click="handleCustomerDetail(formData.memberId)"></el-link>
              </el-form-item>
              <el-form-item label="备注：" prop="note">
                <el-text class="mx-1" v-text="formData.note"></el-text>
              </el-form-item>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'优惠券信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-avatar-three-line"
          >
            <div class="w-100 mx-5">
              <div class="flex cursor-pointer" @click="handleActivityDetail">
                <el-image class="mg_r_1" style="width: 100px; height: 100px" :src="formData.couponImage" :fit="'contain'" />
                <div class="flex_align_t flex_warp flex_1">
                  <div class="w-100">
                    <strong>
                      <el-text class="mx-1" size="large" v-text="formData.couponName"></el-text>
                    </strong>
                    <div>
                      <el-text v-if="formData.validityType === 'PERMANENT'" class="mx-1" type="info" size="small" v-text="`有效期：长期有效`"></el-text>
                      <el-text v-if="formData.validityType === 'DAYS'" class="mx-1" type="info" size="small" v-text="`有效期：${formData.validityValue}天`"></el-text>
                      <el-text v-if="formData.validityType === 'END_DATE'" class="mx-1" type="info" size="small" v-text="`有效期：${formData.validityValue}`"></el-text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'订单状态'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item"
          >
            <el-form-item label="订单状态：" prop="orderState">
              <YTCouponState class="mg_r_1" :state="formData.couponState"></YTCouponState>
              <v-btn color="success" @click="open = true" v-if="formData.allowedTriggers.length > 0" :disabled="!$handleHasBtnPermission('any', 'coupon:edit')">更新状态</v-btn>
            </el-form-item>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div>
      <v-row>
        <v-col>
          <v-btn @click="router.back()">返回</v-btn>
        </v-col>
      </v-row>
    </div>
  </el-form>
  <YTCheckedPanel
      v-if="open"
      :open="open"
      :title="'订单状态'"
      :list="triggerList"
      :hasAll="false"
      :checked-limit="1"
      @cancel="handleCancelPanel"
      @confirm="handleConfirmPanel">
  </YTCheckedPanel>
  <el-drawer
      v-model="drawer"
      :title="drawerCacheType === 1 ? '用户信息' : '优惠券信息'"
      direction="rtl"
      :close="handleCloseDrawer"
      style="text-align: left"
      :size="drawerCacheType === 1 ? '30%' : '50%'"
  >
    <el-skeleton v-if="drawerLoading" :rows="5" animated />
    <div v-else>
      <div v-if="drawerCacheType === 1">
        <YTDrawerMember :drawer-cache-info="drawerCacheInfo"></YTDrawerMember>
      </div>
      <div v-else>
        <YTDrawerItem :drawer-cache-info="drawerCacheInfo"></YTDrawerItem>
      </div>
    </div>
  </el-drawer>
</template>

<style scoped>

</style>